var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page",class:_vm.pageClass},[_c('div',{staticClass:"content"},[_c('zoom-center-transition',{attrs:{"duration":_vm.pageTransitionDuration,"mode":"out-in"}},[_c('router-view')],1),_c('content-footer',{attrs:{"className":'text-center'}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }